import { SET_ROLES } from 'constants/ActionTypes'

const initialState = []

export default function (state = initialState, action) {
  switch (action.type) {
    case SET_ROLES:
      return action.payload
    default:
      return state
  }
}
